import { Head, Link } from '@inertiajs/react'
import Form from './form.tsx'
import type {
  AreaOptionType,
  AreasByCommunityType,
  CommunityOptionType,
  TaxPayerType,
  TaxPayerTypeOptionType,
  TaxPayerTypesByCommunityType,
} from './types.ts'

interface NewProps {
  tax_payer: TaxPayerType
  tax_payer_types: TaxPayerTypeOptionType[]
  tax_payer_types_by_community?: TaxPayerTypesByCommunityType
  areas: AreaOptionType[]
  areas_by_community?: AreasByCommunityType
  communities?: CommunityOptionType[]
}

export default function New({
  tax_payer,
  tax_payer_types,
  tax_payer_types_by_community,
  areas,
  areas_by_community,
  communities,
}: NewProps) {
  return (
    <>
      <Head title="Nouveau contribuable" />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <h1 className="font-bold text-4xl">Nouveau contribuable</h1>

        <Form
          tax_payer={tax_payer}
          tax_payer_types={tax_payer_types}
          tax_payer_types_by_community={tax_payer_types_by_community}
          areas={areas}
          areas_by_community={areas_by_community}
          communities={communities}
          method="post"
          action="/tax_payers"
          submitText="Créer un contribuable"
        />

        <Link
          href="/tax_payers"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Retour aux contribuables
        </Link>
      </div>
    </>
  )
}
